import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaMapMarkerAlt } from 'react-icons/fa';
import { useEffect } from 'react';
// Reusing colors from HomePage
const ACCENT_COLOR_HEX = "#A0522D";
const BG_COLOR_HEX = "#F5F5F5";

// Animation variants
const containerVariant = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { delayChildren: 0.2, staggerChildren: 0.1 }
    }
};

const itemVariant = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { type: "spring", stiffness: 100 } }
};

const CategoryPage = ({currentPath,title, heroImage, description, galleryImages }) => {
    useEffect(() =>{
        window.scrollTo(0,0);
    },[currentPath])

    return (
        <div className="bg-white min-h-screen">
            {/* Hero Section */}
            <div className="relative h-[50vh] w-full">
                <img
                    src={heroImage}
                    alt={title}
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="text-center text-white px-4"
                    >
                        <h1 className="text-5xl md:text-7xl font-bold mb-4 drop-shadow-lg">{title}</h1>
                        <p className="text-xl md:text-2xl font-light">{description}</p>
                    </motion.div>
                </div>
            </div>

            {/* Gallery Section */}
            <section className="py-16 px-6 max-w-7xl mx-auto">
                <motion.div
                    variants={containerVariant}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                >
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ color: ACCENT_COLOR_HEX }}>
                            Latest Trends in {title}
                        </h2>
                        <p className="text-gray-600 max-w-2xl mx-auto">
                            Explore our exclusive collection suitable for every occasion.
                            Visit our store to try them on!
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {galleryImages.map((img, index) => (
                            <motion.div
                                key={index}
                                variants={itemVariant}
                                className="group relative overflow-hidden rounded-xl shadow-lg aspect-[3/4]"
                            >
                                <img
                                    src={img}
                                    alt={`${title} ${index + 1}`}
                                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                />
                                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-6 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                                    <p className="text-white font-semibold text-lg">New Arrival</p>
                                    <button className="text-sm text-white underline mt-2">View Details</button>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>
            </section>

            {/* Call to Action */}
            <section className={`py-16 bg-[${BG_COLOR_HEX}]`}>
                <div className="max-w-4xl mx-auto text-center px-6">
                    <h2 className="text-3xl font-bold mb-6" style={{ color: ACCENT_COLOR_HEX }}>
                        Can't find what you're looking for?
                    </h2>
                    <p className="text-gray-700 text-lg mb-8">
                        We have hundreds of more designs in our store. Video calls available for remote shopping!
                    </p>
                    <div className="flex flex-col sm:flex-row justify-center gap-4">
                        <a
                            href="https://wa.me/91XXXXXXXXXX"
                            className="bg-green-600 text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-green-700 transition flex items-center justify-center gap-2 shadow-lg"
                        >
                            <FaWhatsapp /> Chat on WhatsApp
                        </a>
                        <a
                            href="https://maps.google.com/?cid=13623925468759416509" // Using the same CID as HomePage
                            target="_blank"
                            rel="noreferrer"
                            className="bg-white border-2 px-8 py-3 rounded-full text-lg font-semibold hover:bg-gray-50 transition flex items-center justify-center gap-2 shadow-lg"
                            style={{ color: ACCENT_COLOR_HEX, borderColor: ACCENT_COLOR_HEX }}
                        >
                            <FaMapMarkerAlt /> Visit Store
                        </a>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CategoryPage;
